import React, {useEffect} from "react";
import EventCalendar from "./bits/eventCalendar/eventCalendar";
import {useScrollToTop} from "../../utils/ui/useScrollToTop";
import {useHistory} from "react-router";
import {useTranslation} from "react-i18next";
import {useStores} from "../../stores/useStores";
import {runInAction} from "mobx";
import withRedirectWithoutASelectedVillage from "../../utils/auth/withRedirectWithoutASelectedVillage";
import {QueryParams} from "../../shared/enums/queryParams";
import {observer} from "mobx-react-lite";
import {getEventsUrl} from "../../utils/urlUtils";

// Ignoring this unfortunately because eventsUiStore calls backendcaller before we can mock it
/* istanbul ignore file */
const Events: React.FC = () => {
  const history = useHistory();

  const {
    uiStore: {eventsUiStore, eventCatalogueUiStore},
    uiStore
  } = useStores();
  const {t} = useTranslation(["event"]);
  const currentCalendarView = eventsUiStore.currentCalendarView;
  const setCurrentCalendarView = (selectedView: string) => {
    runInAction(() => (eventsUiStore.currentCalendarView = selectedView));
  };

  runInAction(() => (eventCatalogueUiStore.isModalOpen = false));
  const villageIdQueryParam = `${QueryParams.VillageId}=${uiStore.selectableVillages?.selectedItem?.value}`;

  useEffect(() => {
    return () => {
      eventsUiStore.resetIsCreatingOrEditingFlag();
      eventsUiStore.resetIsViewingEventFlag();
    };
  }, [eventsUiStore]);

  const ScrollToTop = useScrollToTop();

  return (
    <>
      <ScrollToTop />
      <EventCalendar
        switchToEditEvent={(eventId: string, occurrenceDate?: Date | null) =>
          history.push(
            getEventsUrl(
              eventId,
              villageIdQueryParam,
              eventsUiStore.selectedCalendarName,
              t("event:titles.editEvent"),
              occurrenceDate
            )
          )
        }
        switchToViewEvent={(eventId: string, occurrenceDate?: Date | null) => {
          history.push(
            getEventsUrl(
              eventId,
              villageIdQueryParam,
              eventsUiStore.selectedCalendarName,
              t("event:titles.viewEvent"),
              occurrenceDate
            )
          );
        }}
        switchToManageBooking={(
          eventId: string,
          occurrenceDate?: Date | null
        ) =>
          history.push(
            getEventsUrl(
              eventId,
              villageIdQueryParam,
              eventsUiStore.selectedCalendarName,
              t("event:titles.manageBookings"),
              occurrenceDate
            )
          )
        }
        currentCalendarView={currentCalendarView}
        setCurrentCalendarView={setCurrentCalendarView}
        switchToEditEventSeries={(eventId: string) =>
          history.push(
            getEventsUrl(
              eventId,
              villageIdQueryParam,
              eventsUiStore.selectedCalendarName,
              t("event:titles.editEventSeries"),
              null,
              true
            )
          )
        }
        switchToViewEventSeries={(eventId: string) =>
          history.push(
            getEventsUrl(
              eventId,
              villageIdQueryParam,
              eventsUiStore.selectedCalendarName,
              t("event:titles.viewEventSeries"),
              null,
              false
            )
          )
        }
      />
    </>
  );
};

export default withRedirectWithoutASelectedVillage(observer(Events));
